module.exports = __webpack_public_path__ + "src/client/components/Header/header-background@2x.png";